import React from 'react';
import { skills } from '../../data/constants';
import useReveal from '../../hooks/useReveal';
import './styles.css';

export default function Skills() {
  const ref = useReveal();
  const allSkills = Object.values(skills).flat();
  const half = Math.ceil(allSkills.length / 2);
  const row1 = allSkills.slice(0, half);
  const row2 = allSkills.slice(half);

  return (
    <section className="skills" id="skills" ref={ref}>
      <div className="skills__header section">
        <p className="section-label reveal">Skills</p>
        <h2 className="section-title reveal reveal-delay-1">Tech I Work With</h2>
        <p className="section-subtitle reveal reveal-delay-2">
          Technologies and tools I use to build production-grade AI products and full-stack applications.
        </p>
      </div>

      {/* Marquee rows */}
      <div className="marquee reveal reveal-delay-3">
        <div className="marquee__track">
          <div className="marquee__content">
            {[...row1, ...row1].map((skill, i) => (
              <span className="marquee__item" key={i}>{skill}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="marquee marquee--reverse reveal reveal-delay-4">
        <div className="marquee__track marquee__track--reverse">
          <div className="marquee__content">
            {[...row2, ...row2].map((skill, i) => (
              <span className="marquee__item marquee__item--alt" key={i}>{skill}</span>
            ))}
          </div>
        </div>
      </div>

      {/* Category grid */}
      <div className="skills__grid section reveal">
        {Object.entries(skills).map(([category, items]) => (
          <div className="skills__category" key={category}>
            <h3 className="skills__cat-title">{category}</h3>
            <div className="skills__cat-items">
              {items.map((item, i) => (
                <span className="skills__pill" key={i}>{item}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
